import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import "../../styles/Css/HelpCenter.css"

const HelpCenter = () => {
    const [searchQuery, setSearchQuery] = useState('');

    const categories = [
        {
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
            ),
            title: 'Getting Started',
            description: 'Learn the basics and set up your account',
            articles: 12
        },
        {
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                </svg>
            ),
            title: 'Transaction Management',
            description: 'How to create and manage transactions',
            articles: 18
        },
        {
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                    <line x1="3" y1="9" x2="21" y2="9" />
                    <line x1="9" y1="21" x2="9" y2="9" />
                </svg>
            ),
            title: 'Integrations',
            description: 'Connect your tools and platforms',
            articles: 15
        },
        {
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="3" />
                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
                </svg>
            ),
            title: 'Account & Settings',
            description: 'Manage your account preferences',
            articles: 10
        },
        {
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                    <line x1="1" y1="10" x2="23" y2="10" />
                </svg>
            ),
            title: 'Billing & Payments',
            description: 'Invoices, plans, and payment methods',
            articles: 8
        },
        {
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
            ),
            title: 'Security & Privacy',
            description: 'Keep your data safe and secure',
            articles: 6
        }
    ];

    const popularArticles = [
        'How to create your first transaction',
        'Setting up email integration',
        'Understanding AI contract analysis',
        'Inviting team members',
        'Connecting your CRM',
        'Customizing task templates'
    ];

    return (
        <div className="help-page">
            {/* Hero */}
            <section className="help-hero">
                <div className="container">
                    <h1 className="help-hero__title">How can we help you?</h1>
                    <div className="help-hero__search">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="11" cy="11" r="8" />
                            <line x1="21" y1="21" x2="16.65" y2="16.65" />
                        </svg>
                        <input
                            type="text"
                            placeholder="Search for help articles..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                </div>
            </section>

            {/* Categories */}
            <section className="help-categories section">
                <div className="container">
                    <h2 className="section-title">Browse by Category</h2>
                    <div className="categories__grid">
                        {categories.map((category, index) => (
                            <div key={index} className="category-card">
                                <div className="category-card__icon">
                                    {category.icon}
                                </div>
                                <h3 className="category-card__title">{category.title}</h3>
                                <p className="category-card__description">{category.description}</p>
                                <span className="category-card__count">{category.articles} articles</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Popular Articles */}
            <section className="help-popular section">
                <div className="container">
                    <h2 className="section-title">Popular Articles</h2>
                    <div className="popular__grid">
                        {popularArticles.map((article, index) => (
                            <a key={index} href="#" className="popular-article">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                    <polyline points="14 2 14 8 20 8" />
                                </svg>
                                <span>{article}</span>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="arrow">
                                    <line x1="5" y1="12" x2="19" y2="12" />
                                    <polyline points="12 5 19 12 12 19" />
                                </svg>
                            </a>
                        ))}
                    </div>
                </div>
            </section>

            {/* Contact Support */}
            <section className="help-contact">
                <div className="container">
                    <div className="help-contact__card">
                        <h2 className="help-contact__title">Still need help?</h2>
                        <p className="help-contact__description">
                            Our support team is available Monday through Friday, 9am - 6pm EST.
                        </p>
                        <Link to="/contact" className="btn btn-primary">
                            Contact Support
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HelpCenter;
